
import Lib from '../../commons/lib';

export default class Service {
  static kedvezmenyUrl = window.location.origin + '/api/kedvezmeny/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  static szervezetUrl = window.location.origin + '/api/szervezet/';

  static jegyUrl = window.location.origin + '/api/jegy/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  static penzugyUrl = window.location.origin + '/api/penzugykozos/';

  static partnerUrl = window.location.origin + '/api/partner/';

  // VÁSÁRLÓIKÁRTYA START

  static addVasarloiKartya(vasarloiKartya, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'vasarloikartya',
      data: vasarloiKartya,
    }], fnDone);
  }

  static addVasarloiKartyaGroup(vasarloiKartya, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'vasarloikartya/group',
      data: vasarloiKartya,
    }], fnDone);
  }

  static getVasarloiKartya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya',
      params: { id: id }
    }], fnDone);
  }

  static getVasarloiKartyaAr(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/price',
      data: ids
    }], fnDone);
  }

  static listVasarloiKartya(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/list',
      data: filters
    }], fnDone);
  }

  static listVasarloiKartyaAzons(azon, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/list/azon',
      params: { azon }
    }], fnDone);
  }

  static listVasarloiKartyaCsoport(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/list/csoport',
    }], fnDone);
  }

  static listVasarloiKartyaTulajdonosok(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/tulajdonos/list',
      params: { id }
    }], fnDone);
  }

  static editVasarloiKartya(vasarloiKartya, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya',
      data: vasarloiKartya,
      params: { id: vasarloiKartya.id }
    }], fnDone);
  }

  static activateVasarloiKartya(vasarloiKartya, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/activate',
      data: vasarloiKartya,
    }], fnDone);
  }

  static deleteVasarloiKartya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'vasarloikartya',
      params: { id: id }
    }], fnDone);
  }

  static deActivateVasarloiKartya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'vasarloikartya/deactivate',
      params: { id: id }
    }], fnDone);
  }

  static reActivateVasarloiKartya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/reactivate',
      params: { id: id }
    }], fnDone);
  }

  static renewalVasarloiKartya(ids, time, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/group/renewal',
      data: { ids: ids, time: time },
    }], fnDone);
  }

  static cancelVasarloiKartya(ids, time, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/group/cancel',
      data: { ids: ids, time: time },
    }], fnDone);
  }

  static printVasarloiKartya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/print',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      params: { id: id }
    }], fnDone);
  }

  static printVasarloiKartyaGroup(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/group/print',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: ids,
    }], fnDone);
  }

  static exportVasarloiKartyaGroup(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'vasarloikartya/export',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: ids,
    }], fnDone);
  }

  static insertPartnerBase(tulajdonos, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'vasarloikartya/partner',
      data: tulajdonos,
    }], fnDone);
  }

  /* static listKartyaTipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/enum/kartyatipus',
    }], fnDone);
  } */

  // VÁSÁRLÓIKÁRTYA END


  // FUNKCIÓ-KEDVEZMÉNY START

  static addFunkcioKedvezmeny(funkcioKedvezmeny, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny',
      data: funkcioKedvezmeny,
    }], fnDone);
  }

  static getFunkcioKedvezmeny(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny',
      params: { funkcioId: id }
    }], fnDone);
  }

  static listFunkcioKedvezmeny(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny/list',
    }], fnDone);
  }

  static listFunkcio(input, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny/funkcio/list',
      params: { text: input }
    }], fnDone);
  }

  static editFunkcioKedvezmeny(funkcioKedvezmeny, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny',
      data: funkcioKedvezmeny,
      params: { funkcioId: funkcioKedvezmeny.id }
    }], fnDone);
  }

  static deleteFunkcioKedvezmeny(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'funkciokedvezmeny',
      params: { funkcioId: id }
    }], fnDone);
  }

  // FUNKCIÓ-KEDVEZMÉNY END

  // KEDVEZMÉNY START

  static addKedvezmeny(kedvezmeny, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'kedvezmeny',
      data: kedvezmeny,
    }], fnDone);
  }

  static getKedvezmeny(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny',
      params: { id: id }
    }], fnDone);
  }

  static listKedvezmeny(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny/list',
    }], fnDone);
  }

  static listKedvezmenyListAlanya(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny/list/alany',
      params: { id: id }
    }], fnDone);
  }

  static listKedvezmenyTipusEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny/enum/tipus',
    }], fnDone);
  }

  static listCiklusEgysegEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny/enum/ciklus',
    }], fnDone);
  }

  static listKedvezmenyAlanya(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmeny/enum/alanya',
    }], fnDone);
  }

  static editKedvezmeny(kedvezmeny, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'kedvezmeny',
      data: kedvezmeny,
    }], fnDone);
  }

  static deleteKedvezmeny(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'kedvezmeny',
      params: { id: id }
    }], fnDone);
  }

  // KEDVEZMÉNY END

  // KEDVEZMÉNYALANY START

  static addKedvezmenyAlany(kedvezmenyAlany, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'alany',
      data: kedvezmenyAlany,
    }], fnDone);
  }

  static getKedvezmenyAlany(kedvezmenyId, alanyId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'alany',
      params: { kedvezmenyId: kedvezmenyId, alanyId: alanyId }
    }], fnDone);
  }

  static editKedvezmenyAlany(kedvezmenyAlany, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'alany',
      data: kedvezmenyAlany,
    }], fnDone);
  }

  static deleteKedvezmenyAlany(kedvezmenyId, alanyId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'alany',
      params: { kedvezmenyId: kedvezmenyId, alanyId: alanyId }
    }], fnDone);
  }

  // KEDVEZMÉNYALANY END

  // VÁSÁRLÓI KÁRTYATÍPUS START

  static loadCsoportParamOptions(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/enum/csoport',
    }], fnDone);
  }

  static loadTulajdonosOptions(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/enum/tulajdonos',
    }], fnDone);
  }

  static loadDatumOptions(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/enum/datum',
    }], fnDone);
  }

  static loadVegeOptions(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/enum/vege',
    }], fnDone);
  }

  static loadVegeTipusOptions(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/enum/vegetipus',
    }], fnDone);
  }

  static addKartyaTipus(kartyaTipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'kartyatipus',
      data: kartyaTipus,
    }], fnDone);
  }

  static getKartyaTipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus',
      params: { id: id }
    }], fnDone);
  }

  static viewKartyaTipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/view',
      params: { id: id }
    }], fnDone);
  }

  static listKartyaTipus(generalas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/list',
      params: { generalas: generalas }
    }], fnDone);
  }

  static listKartyaTipusSelect(generalas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/list/select',
      params: { generalas: generalas }
    }], fnDone);
  }

  static editKartyaTipus(kartyaTipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'kartyatipus',
      data: kartyaTipus,
    }], fnDone);
  }

  static deleteKartyaTipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'kartyatipus',
      params: { id: id }
    }], fnDone);
  }

  static checkKartyaTipusArDeleteEdit(kartyaTipusArId, edit, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyatipus/checkardeleteedit',
      params: { kartyaTipusArId, edit }
    }], fnDone);
  }

  // VÁSÁRLÓI KÁRTYA TÍPUS END


  // VÁSÁRLÓIKÁRTYA GENERÁLÁS START

  static addKartyaGenerelas(kartyaGeneralas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.kedvezmenyUrl + 'kartyageneralas',
      data: kartyaGeneralas,
    }], fnDone);
  }

  static getKartyaGeneralas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyageneralas',
      params: { id: id }
    }], fnDone);
  }

  static listKartyaGeneralas(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      data: param,
      url: Service.kedvezmenyUrl + 'kartyageneralas/list',
    }], fnDone);
  }

  static listVasarloiKartyaByGeneralas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kartyageneralas/list/bygeneralas',
      params: { id: id }
    }], fnDone);
  }

  static exportKartyaGeneralas(id, selectedIds, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'kartyageneralas/export',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      params: { id: id },
      data: selectedIds,
    }], fnDone);
  }

  static deleteKartyaGeneralas(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.kedvezmenyUrl + 'kartyageneralas',
      params: { id: id }
    }], fnDone);
  }

  // VÁSÁRLÓI KÁRTYATÍPUS GENERÁLÁS END

  // VÁSÁRLÓI KÁRTYA LISTA START

  static listForgalom(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'lists/forgalom',
      data: filters
    }], fnDone);
  }

  static listForgalomXlsx(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'lists/xlsx/forgalom',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: filters
    }], fnDone);
  }

  static listFelhasznalas(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'lists/felhasznalas',
      data: filters
    }], fnDone);
  }

  static listFelhasznalasXlsx(filters, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.kedvezmenyUrl + 'lists/xlsx/felhasznalas',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: filters
    }], fnDone);
  }

  static listBontas(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'lists/enum/bontas',
    }], fnDone);
  }

  static listAllapot(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'lists/enum/statusz',
    }], fnDone);
  }


  // VÁSÁRLÓI KÁRTYA LISTA START


  // KEDVEZMÉNYTÍPUS START

  static listKedvezmenyTipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'kedvezmenytipus/list',
    }], fnDone);
  }

  // KEDVEZMÉNYTÍPUS END


  // CÉGADAT START

  static listKiallito(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.cegadatUrl + 'cegadat/list',
      params: { aktiv: true }
    }], fnDone);
  }

  // CÉGADAT END


  // SZERVEZET START

  static listDolgozo(input, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.szervezetUrl + 'szemely/list',
      params: { param: input },
    }], fnDone);
  }

  // SZERVEZET END


  // JEGY START

  static listJegy(input, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.jegyUrl + 'jegy/list',
      params: { param: input },
    }], fnDone);
  }

  // JEGY END


  // HELYSZIN START

  static listHelyszinSelect(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/list/select',
      params: { tipus: 'SAJAT' },
    }], fnDone);
  }

  // HELYSZIN END

  // PENZUGY END

  static listFizmodAktiv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'fizmod/aktiv',
      args: { requestType: 'fizmod-list' }
    }], fnDone);
  }

  static listPenznemAktiv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugyUrl + 'penznem/aktiv',
      args: { requestType: 'penznem-list' }
    }], fnDone);
  }

  // PENZUGY END

  // PARTNER START

  static listPartnercsoportAktiv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'partnercsoport/aktiv',
    }], fnDone);
  }

  static listPartner(partnerCsoportId, id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.partnerUrl + 'search/getlist',
      params: { service: 'VASARLOI_KARTYA_LIST', csoportid: partnerCsoportId },
      data: id && [id]
    }], fnDone);
  }

  static searchTulajdonos(kartyaTipusId, text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kedvezmenyUrl + 'vasarloikartya/searchtulajdonos',
      args: { requestType: 'search-searchtulajdonos' },
      params: {
        id: kartyaTipusId,
        text: text
      }
    }], fnDone);
  }

  static deletePartner(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.partnerUrl + 'partner',
      args: { requestType: 'partner-delete' },
      params: {
        id: id,
      },
    }], fnDone);
  }

  static setHozzajarul(idMap, op, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.partnerUrl + 'gdprhozzaj',
      args: { requestType: 'jogalap-hozzajarul-put' },
      params: {
        op: op
      },
      data: Object.fromEntries(idMap.entries())
    }], fnDone);
  }

  static pdfGen(pid, jid, cid, begin, end, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'gdprhozzaj/pdf',
      args: { requestType: 'jogalap-pdf-kuld' },
      acceptType: 'application/json; charset=utf-8, text/plain; charset=utf-8, application/octet-stream',
      params: {
        pid: pid,
        jid: jid,
        cid: cid,
        begin: begin,
        end: end
      },
    }], fnDone);
  }

  static listTelefonEnum(fnDone) {
      Lib.MicroServices.requestService([{
        method: 'GET',
        url: Service.partnerUrl + 'partner/telefonenum',
        args: { requestType: 'partner-telefonenum-list' }
      }], fnDone);
    }

  // PARTNER END
}
